import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createSpanIn} from '../../../../shared/scripts/ui_utils/DomUtils'

export class UIMRoomGamemodeMapCardView {
    private readonly cardContainer: HTMLDivElement
    private readonly cardBodyContainer: HTMLDivElement
    private readonly onClick?: (() => void) | undefined

    constructor(container: HTMLDivElement, text: TranslationObject, icon: LobbyImage, body: HTMLDivElement, isCardLocked: boolean, onClick?: () => void) {
        this.onClick = onClick
        this.cardContainer = createDivIn(container, 'm-room-settings-card-container')

        const cardHeaderContainer = createDivIn(this.cardContainer, 'm-room-settings-card-header-container')
        this.cardBodyContainer = createDivIn(this.cardContainer, 'm-room-settings-card-body-container')
        this.cardBodyContainer.style.display = 'none'

        this.createCard(cardHeaderContainer, text, icon, body, isCardLocked)
        this.createClickInteraction()
    }

    setSelect(isSelected: boolean) {
        if(isSelected) return this.cardContainer.classList.add('m-room-settings-card-container-selected')

        this.cardContainer.classList.remove('m-room-settings-card-container-expanded', 'm-room-settings-card-container-selected')
        this.cardBodyContainer.style.display = 'none'
    }

    private createClickInteraction() {
        this.cardContainer.onclick = () => {
            this.cardContainer.classList.toggle('m-room-settings-card-container-expanded')
            this.cardBodyContainer.style.display = this.cardBodyContainer.style.display == 'none' ? 'flex' : 'none'
            this.onClick?.()
        }
    }

    private createCard(cardContainer: HTMLDivElement, title: TranslationObject, icon: LobbyImage, body: HTMLDivElement, isCardLocked: boolean) {
        const titleContainer = createDivIn(cardContainer, 'm-room-settings-card-title-container')
        createSpanIn(titleContainer, 'm-room-settings-card-title', title)
        createSpanIn(titleContainer, 'm-room-settings-card-become-member-text', {key: 'strings:homePage.becomeAMemberToUnlock'})

        const lockedIconContainer = createDivIn(cardContainer, 'm-room-settings-card-locked-icon-container')
        createImgIn(lockedIconContainer, LobbyImage.Lock, 'm-room-settings-lock-icon')
        createImgIn(lockedIconContainer, icon, 'm-room-settings-card-icon')

        this.cardBodyContainer.append(body.cloneNode(true))
        if(isCardLocked) this.cardContainer.classList.add('m-room-settings-card-container-locked')
    }
}
